import ResourceGuide from "@/components/ResourceGuide";

const EnterpriseGeoGuidePage = () => <ResourceGuide slug="enterprise-geo-guide" />;

export default EnterpriseGeoGuidePage;
